import React, { useEffect } from 'react';
import Header from '../componentes/header/header';
import Footer from '../componentes/footer/footer';
import './trinco_mais.css';
import { assets } from '../assets/assets';

const TrincoMais = () => {
  useEffect(() => {
    document.title = "Trinco | Trinco+";
  }, []);

  const steps = [
    {
      img: assets.coletaMotoboy,
      title: "Coleta",
      desc: "Solicite pelo WhatsApp e coletamos no local que você preferir."
    },
    {
      img: assets.consertando, // Ícone de Loja
      title: "Serviço",
      desc: "Seu item é atendido por nossos especialistas em uma unidade Trinco."
    },
    {
      img: assets.devolvendo,
      title: "Entrega",
      desc: "Após o serviço, entregamos de volta no endereço e horário que você escolher."
    }
  ];

  const abrirWhatsapp = () => {
    const numero = "5571999556884"; // Substitua pelo seu número
    const texto = encodeURIComponent("Olá! Gostaria de agendar uma coleta pelo Trinco+");
    window.open(`https://wa.me/${numero}?text=${texto}`, '_blank');
  };

  return (<>
    <Header />
    <div className="trinco-container">
      <header className="trinco-header">
        <h1>Trinco<span>+</span></h1>
        <p>A Trinco agora vai até você.</p>
      </header>

      <section className="trinco-steps">
        {steps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="step-icon-wrapper">
              <img src={step.img} alt={step.title} className="step-icon" />
              <span className="step-number">{index + 1}</span>
            </div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </div>
        ))}
      </section>

      <div className="trinco-cta">
        <h2>Precisa de algo agora?</h2>
        <p>Fale com a Trinco pelo WhatsApp e resolva em poucos minutos.</p>
        <button onClick={abrirWhatsapp} className="btn-whatsapp">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
          />
          Falar no WhatsApp
        </button>
      </div>
    </div>
    <Footer />
  </>
  );
};

export default TrincoMais;